import {
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appResize]',
  standalone: true,
})
export class ResizeDirective implements OnDestroy {
  @Output()
  resizeEvent: EventEmitter<{ width: number; height: number }> =
    new EventEmitter();

  private resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.contentRect.width) {
        this.zone.run(() => {
          this.resizeEvent.emit({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          });
        });
      }
    }
  });

  constructor(private el: ElementRef, private zone: NgZone) {
    const htmlElement = this.el.nativeElement;
    if (htmlElement) {
      this.resizeObserver.observe(htmlElement);
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver.unobserve(this.el.nativeElement);
  }
}
